package at.theatervogelweide.admin.contract.board

import at.theatervogelweide.admin.contract.AdminResult
import at.theatervogelweide.admin.contract.VersionedId
import kotlinx.rpc.annotations.Rpc

/**
 * Vorstand (#23), in the order the public site shows it. The people to choose from come from
 * [at.theatervogelweide.admin.contract.people.PeopleService.list].
 */
@Rpc
interface BoardService {
    suspend fun list(): AdminResult<List<BoardMemberEntry>>

    /** The new member goes to the end of the list, as with the public server's board editor. */
    suspend fun create(draft: BoardMemberDraft): AdminResult<BoardMemberEntry>

    suspend fun save(member: VersionedId, draft: BoardMemberDraft): AdminResult<BoardMemberEntry>

    /** [order] must list every member, each with the version the web app last saw; answers with the new list. */
    suspend fun reorder(order: List<VersionedId>): AdminResult<List<BoardMemberEntry>>

    /** Removes the person from the board; the person stays. */
    suspend fun delete(member: VersionedId): AdminResult<Unit>
}
